angular.module('backstage.directives.validation', [])
    .directive('bsIpValidation', require('./bsIpValidation'))
    .directive('bsCidrValidation', require('./bsCidrValidation'))
    .directive('bsUrlValidation', require('./bsUrlValidation'))
    .directive('bsHexColourValidation', require('./bsHexColourValidation'))
    .directive('bsMaxFileSizeValidation', require('./bsMaxFileSizeValidation'));
